// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.endgame_character {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: clamp(120px, 15vw, 180px);
    height: clamp(120px, 15vw, 180px);
    padding: clamp(8px, 1vh, 12px);
    padding-top: clamp(24px, 3vh, 32px);
    isolation: isolate;
    background: linear-gradient(
        135deg,
        transparent 0%,
        rgba(37, 43, 54, 0.05) 15%,
        rgba(37, 43, 54, 0.95) 50%,
        rgba(37, 43, 54, 0.05) 85%,
        transparent 100%
    );
    border-radius: 8px;
    transition: all 0.3s ease;
}

.endgame_character::before {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(
        135deg,
        transparent 0%,
        rgba(81, 253, 255, 0.02) 20%,
        rgba(81, 253, 255, 0.1) 50%,
        rgba(81, 253, 255, 0.02) 80%,
        transparent 100%
    );
    border-radius: 8px;
    z-index: -1;
}

.endgame_character::after {
    content: '';
    position: absolute;
    top: 0;
    left: 10%;
    right: 10%;
    height: 1px;
    background: linear-gradient(
        90deg,
        transparent 0%,
        rgba(81, 253, 255, 0.1) 20%,
        rgba(81, 253, 255, 0.3) 50%,
        rgba(81, 253, 255, 0.1) 80%,
        transparent 100%
    );
    opacity: 0.5;
}

.endgame_character_level {
    position: absolute;
    top: clamp(4px, 0.8vh, 8px);
    right: clamp(8px, 1vw, 12px);
    font-family: 'Kim';
    font-size: clamp(12px, 1.5vh, 16px);
    font-weight: 600;
    color: #ffa600;
    text-shadow: 0 0 8px rgba(255, 166, 0, 0.5);
    display: flex;
    align-items: center;
    gap: 4px;
}

.endgame_character_level span {
    color: #ffffff;
}

.endgame_character_level_container {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
    width: 100%;
}

.endgame_character_xp_container {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 2px;
}

.endgame_character_xp_label {
    font-size: clamp(8px, 1vh, 10px);
    color: #71deff;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin-left: 1px;
}

.endgame_character_xp_bar {
    width: 100%;
    height: 4px;
    background: rgba(28, 31, 37, 0.5);
    border-radius: 2px;
    /* overflow: hidden; */
}

.endgame_character_xp_fill {
    height: 100%;
    background: #71deff;
    box-shadow: 0 0 8px rgba(113, 222, 255, 0.5);
    transition: width 0.1s linear;
}

.endgame_character_xp_fill.reset {
    transition: none;
}

.endgame_character_portrait {
    width: clamp(80px, 10vh, 120px);
    height: clamp(80px, 10vh, 120px);
    position: relative;
    margin: 8px 0;
    display: flex;
    justify-content: center;
    align-items: center;
}

.endgame_character_portrait .char_portrait {
    width: 100%;
    height: 100%;
    margin-left: 10px;
    background-repeat: no-repeat;
    transform: scale(1);
    animation: animate-sprite 0.7s steps(1) infinite;
}

.endgame_character_portrait .char_portrait.victory-animation {
    animation: animate-sprite-victory 0.7s steps(1) infinite;
}

@keyframes animate-sprite-victory {
    0% { background-position: -900px -190px; }
    50% { background-position: -1045px -190px; }
    100% { background-position: -1190px -190px; }
}

.endgame_character_name {
    font-family: 'Kim';
    font-size: clamp(12px, 1.5vh, 16px);
    font-weight: 600;
    color: #ffffff;
    text-align: center;
    margin-top: 8px;
    text-shadow: 0 0 8px rgba(255, 255, 255, 0.3);
}

.endgame_character_class {
    font-family: 'Kim';
    font-size: clamp(10px, 2vh, 14px);
    color: #71deff;
    text-transform: uppercase;
    text-align: center;
    margin-top: 4px;
}

.endgame_character_exp {
    font-size: clamp(6px, 0.8vh, 8px);
    color: #ffffff;
}

.endgame_character_expVal {
    font-size: clamp(6px, 0.8vh, 8px);
    color: #71deff;
}

.endgame_character_exp_bg {
    background-color: #1c1f25;
    height: clamp(3px, 0.5vh, 4px);
    border-radius: 2px;
    /* overflow: hidden; */
}

.endgame_character_lvlup {
    position: absolute;
    top: -12px;
    left: 50%;
    transform: translateX(-50%);
    background: linear-gradient(90deg, #ffd700, #ffa600);
    color: #1c1f25;
    font-size: clamp(10px, 2.5vw, 12px);
    font-weight: 700;
    padding: clamp(4px, 1vh, 6px) clamp(12px, 2vw, 16px);
    border-radius: 12px;
    white-space: nowrap;
    box-shadow: 
        0 0 20px rgba(255, 166, 0, 0.6),
        0 0 40px rgba(255, 166, 0, 0.3);
    animation: levelUpFloat 2s ease-in-out infinite;
    z-index: 2;
    pointer-events: none;
    will-change: transform;
}

.endgame_character.leveling-up::before {
    content: '';
    position: absolute;
    top: -20%;
    left: -20%;
    right: -20%;
    bottom: -20%;
    background: 
        /* Delayed sparkles */
        radial-gradient(circle at 50% 30%, rgba(255, 215, 0, 0.8) 0%, transparent 7%),
        radial-gradient(circle at 25% 50%, rgba(255, 215, 0, 0.8) 0%, transparent 7%),
        radial-gradient(circle at 75% 50%, rgba(255, 215, 0, 0.8) 0%, transparent 7%),
        radial-gradient(circle at 50% 70%, rgba(255, 215, 0, 0.8) 0%, transparent 7%);
    animation: sparkles 1.2s ease-out 0.15s forwards;
    pointer-events: none;
    mix-blend-mode: screen;
}

.endgame_character.leveling-up::after {
    content: '';
    position: absolute;
    top: -20%;
    left: -20%;
    right: -20%;
    bottom: -20%;
    background: 
        /* Inner sparkles - brighter and closer */
        radial-gradient(circle at 30% 40%, rgba(255, 215, 0, 0.9) 0%, transparent 6%),
        radial-gradient(circle at 70% 45%, rgba(255, 215, 0, 0.9) 0%, transparent 6%),
        radial-gradient(circle at 40% 60%, rgba(255, 215, 0, 0.9) 0%, transparent 6%),
        radial-gradient(circle at 60% 55%, rgba(255, 215, 0, 0.9) 0%, transparent 6%),
        /* Outer sparkles - softer and spread out */
        radial-gradient(circle at 20% 20%, rgba(255, 215, 0, 0.7) 0%, transparent 8%),
        radial-gradient(circle at 80% 25%, rgba(255, 215, 0, 0.7) 0%, transparent 8%),
        radial-gradient(circle at 15% 70%, rgba(255, 215, 0, 0.7) 0%, transparent 8%),
        radial-gradient(circle at 85% 75%, rgba(255, 215, 0, 0.7) 0%, transparent 8%),
        /* Background glow sparkles */
        radial-gradient(circle at 40% 30%, rgba(255, 215, 0, 0.5) 0%, transparent 12%),
        radial-gradient(circle at 60% 70%, rgba(255, 215, 0, 0.5) 0%, transparent 12%);
    animation: sparkles 1.2s ease-out forwards;
    pointer-events: none;
    mix-blend-mode: screen;
}

@keyframes levelUpFloat {
    0%, 100% {
        transform: translateX(-50%) translateY(0);
    }
    50% {
        transform: translateX(-50%) translateY(-4px);
    }
}

@keyframes sparkles {
    0% { 
        opacity: 0; 
        transform: scale(0.8) rotate(-5deg); 
    }
    15% {
        opacity: 0.3;
        transform: scale(0.9) rotate(-3deg);
    }
    50% { 
        opacity: 1; 
        transform: scale(1.1) rotate(2deg); 
    }
    75% {
        opacity: 0.6;
        transform: scale(1.15) rotate(4deg);
    }
    100% { 
        opacity: 0; 
        transform: scale(1.2) rotate(5deg); 
    }
}

@media screen and (max-width: 480px) {
    .endgame_character_lvlup {
        top: -8px;
        padding: 3px 10px;
        border-radius: 8px;
    }
}

.endgame_character.question-mark-mode {
    cursor: pointer;
    transition: transform 0.3s ease;
    width: clamp(120px, 15vw, 180px);
    height: clamp(120px, 15vw, 180px);
    padding: clamp(8px, 1vh, 12px);
    padding-top: clamp(24px, 3vh, 32px);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: linear-gradient(
        135deg,
        transparent 0%,
        rgba(37, 43, 54, 0.05) 15%,
        rgba(37, 43, 54, 0.95) 50%,
        rgba(37, 43, 54, 0.05) 85%,
        transparent 100%
    );
    border-radius: 8px;
}

.endgame_character.question-mark-mode::before {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(
        135deg,
        transparent 0%,
        rgba(81, 253, 255, 0.02) 20%,
        rgba(81, 253, 255, 0.1) 50%,
        rgba(81, 253, 255, 0.02) 80%,
        transparent 100%
    );
    border-radius: 8px;
    z-index: -1;
}

.endgame_character.question-mark-mode .endgame_character_portrait {
    width: clamp(80px, 10vh, 120px);
    height: clamp(80px, 10vh, 120px);
    margin: 8px 0;
}

.endgame_character.question-mark-mode .char_portrait {
    display: none;
}

.endgame_character.question-mark-mode .question-mark {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: 'Kim';
    font-size: clamp(48px, 8vw, 72px);
    color: #3c616c;
    text-shadow: 0 0 20px rgba(81, 253, 255, 0.2);
    margin-left: 0;
}

.endgame_character.question-mark-mode:hover {
    transform: translateY(-5px);
    border-color: #51fdff;
    box-shadow: 0 0 20px rgba(81, 253, 255, 0.2);
}

@media screen and (max-width: 480px) {
    .endgame_character,
    .endgame_character.question-mark-mode {
        width: clamp(100px, 12vw, 160px);
        height: clamp(100px, 12vw, 160px);
        padding: clamp(6px, 0.8vh, 10px);
        padding-top: clamp(20px, 2.5vh, 28px);
    }

    .endgame_character.question-mark-mode .endgame_character_portrait {
        width: clamp(60px, 8vh, 100px);
        height: clamp(60px, 8vh, 100px);
        margin: 6px 0;
    }

    .endgame_character.question-mark-mode .question-mark {
        font-size: clamp(36px, 6vw, 54px);
    }
}

/* Add hover effect for non-question-mark cards */
.endgame_character:not(.question-mark-mode):hover {
    transform: translateY(-5px) scale(1.02);
    box-shadow: 
        0 5px 15px rgba(81, 253, 255, 0.1),
        0 0 30px rgba(81, 253, 255, 0.05);
}

.endgame_character:not(.question-mark-mode):hover::before {
    opacity: 1;
    background: linear-gradient(
        135deg,
        transparent 0%,
        rgba(81, 253, 255, 0.04) 15%,
        rgba(81, 253, 255, 0.15) 50%,
        rgba(81, 253, 255, 0.04) 85%,
        transparent 100%
    );
}

.endgame_character:not(.question-mark-mode):hover .endgame_character_name {
    text-shadow: 0 0 12px rgba(255, 255, 255, 0.5);
}

.endgame_character:not(.question-mark-mode):hover .endgame_character_class {
    color: #9ee5ff;
    text-shadow: 0 0 8px rgba(113, 222, 255, 0.5);
}

.endgame_character.clickable {
    cursor: pointer;
}

/* Enhance hover effect for clickable cards */
.endgame_character.clickable:hover {
    transform: translateY(-5px) scale(1.02);
    box-shadow: 
        0 5px 15px rgba(81, 253, 255, 0.1),
        0 0 30px rgba(81, 253, 255, 0.05);
}

.endgame_character.clickable:hover::before {
    opacity: 1;
    background: linear-gradient(
        135deg,
        transparent 0%,
        rgba(81, 253, 255, 0.04) 15%,
        rgba(81, 253, 255, 0.15) 50%,
        rgba(81, 253, 255, 0.04) 85%,
        transparent 100%
    );
}

.endgame_character.clickable:hover .endgame_character_name {
    text-shadow: 0 0 12px rgba(255, 255, 255, 0.5);
}

.endgame_character.clickable:hover .endgame_character_class {
    color: #9ee5ff;
    text-shadow: 0 0 8px rgba(113, 222, 255, 0.5);
}

.endgame_character.selected {
    box-shadow: 
        0 0 0 2px #51fdff,
        0 0 15px rgba(81, 253, 255, 0.3);
}

.endgame_character.selected::before {
    background: linear-gradient(
        135deg,
        transparent 0%,
        rgba(81, 253, 255, 0.04) 15%,
        rgba(81, 253, 255, 0.15) 50%,
        rgba(81, 253, 255, 0.04) 85%,
        transparent 100%
    );
    opacity: 1;
}

.endgame_character.selected .endgame_character_name {
    color: #9ee5ff;
    text-shadow: 0 0 12px rgba(113, 222, 255, 0.5);
}

.endgame_character.selected .endgame_character_class {
    color: #51fdff;
    text-shadow: 0 0 8px rgba(81, 253, 255, 0.5);
}

/* Combine hover and selected states */
.endgame_character.selected:hover {
    box-shadow: 
        0 0 0 2px #51fdff,
        0 0 20px rgba(81, 253, 255, 0.4),
        0 5px 15px rgba(81, 253, 255, 0.2);
}

.endgame_character_sp_badge {
    position: absolute;
    top: clamp(4px, 0.8vh, 8px);
    left: clamp(8px, 1vw, 12px);
    background: linear-gradient(135deg, #ff4646, #ff0000);
    color: white;
    font-family: 'Kim';
    font-size: clamp(10px, 1.2vh, 14px);
    font-weight: 600;
    padding: 2px clamp(4px, 0.5vw, 6px);
    border-radius: 4px;
    text-transform: uppercase;
    box-shadow: 0 0 8px rgba(255, 0, 0, 0.4);
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
    animation: spBadgePulse 2s ease-in-out infinite;
}

@keyframes spBadgePulse {
    0% {
        box-shadow: 0 0 8px rgba(255, 0, 0, 0.4);
        transform: scale(1);
    }
    50% {
        box-shadow: 0 0 12px rgba(255, 0, 0, 0.6),
                    0 0 20px rgba(255, 0, 0, 0.2);
        transform: scale(1.05);
    }
    100% {
        box-shadow: 0 0 8px rgba(255, 0, 0, 0.4);
        transform: scale(1);
    }
}`, "",{"version":3,"sources":["webpack://./src/components/HUD/CharacterCard.style.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,gCAAgC;IAChC,iCAAiC;IACjC,8BAA8B;IAC9B,mCAAmC;IACnC,kBAAkB;IAClB;;;;;;;KAOC;IACD,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR;;;;;;;KAOC;IACD,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,UAAU;IACV,WAAW;IACX;;;;;;;KAOC;IACD,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,2BAA2B;IAC3B,4BAA4B;IAC5B,kBAAkB;IAClB,mCAAmC;IACnC,gBAAgB;IAChB,cAAc;IACd,2CAA2C;IAC3C,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,QAAQ;IACR,WAAW;AACf;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,gCAAgC;IAChC,cAAc;IACd,yBAAyB;IACzB,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,iCAAiC;IACjC,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,4CAA4C;IAC5C,6BAA6B;AACjC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,+BAA+B;IAC/B,gCAAgC;IAChC,kBAAkB;IAClB,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,4BAA4B;IAC5B,mBAAmB;IACnB,gDAAgD;AACpD;;AAEA;IACI,wDAAwD;AAC5D;;AAEA;IACI,KAAK,kCAAkC,EAAE;IACzC,MAAM,mCAAmC,EAAE;IAC3C,OAAO,mCAAmC,EAAE;AAChD;;AAEA;IACI,kBAAkB;IAClB,mCAAmC;IACnC,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,6CAA6C;AACjD;;AAEA;IACI,kBAAkB;IAClB,iCAAiC;IACjC,cAAc;IACd,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,iCAAiC;IACjC,cAAc;AAClB;;AAEA;IACI,iCAAiC;IACjC,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,8BAA8B;IAC9B,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,2BAA2B;IAC3B,oDAAoD;IACpD,cAAc;IACd,mCAAmC;IACnC,gBAAgB;IAChB,oDAAoD;IACpD,mBAAmB;IACnB,mBAAmB;IACnB;;uCAEmC;IACnC,+CAA+C;IAC/C,UAAU;IACV,oBAAoB;IACpB,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,WAAW;IACX,YAAY;IACZ;;;;;qFAKiF;IACjF,gDAAgD;IAChD,oBAAoB;IACpB,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,WAAW;IACX,YAAY;IACZ;;;;;;;;;;;;;sFAakF;IAClF,0CAA0C;IAC1C,oBAAoB;IACpB,sBAAsB;AAC1B;;AAEA;IACI;QACI,yCAAyC;IAC7C;IACA;QACI,4CAA4C;IAChD;AACJ;;AAEA;IACI;QACI,UAAU;QACV,mCAAmC;IACvC;IACA;QACI,YAAY;QACZ,mCAAmC;IACvC;IACA;QACI,UAAU;QACV,kCAAkC;IACtC;IACA;QACI,YAAY;QACZ,mCAAmC;IACvC;IACA;QACI,UAAU;QACV,kCAAkC;IACtC;AACJ;;AAEA;IACI;QACI,SAAS;QACT,iBAAiB;QACjB,kBAAkB;IACtB;AACJ;;AAEA;IACI,eAAe;IACf,+BAA+B;IAC/B,gCAAgC;IAChC,iCAAiC;IACjC,8BAA8B;IAC9B,mCAAmC;IACnC,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB;;;;;;;KAOC;IACD,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR;;;;;;;KAOC;IACD,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,+BAA+B;IAC/B,gCAAgC;IAChC,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,iCAAiC;IACjC,cAAc;IACd,6CAA6C;IAC7C,cAAc;AAClB;;AAEA;IACI,2BAA2B;IAC3B,qBAAqB;IACrB,4CAA4C;AAChD;;AAEA;IACI;;QAEI,gCAAgC;QAChC,iCAAiC;QACjC,gCAAgC;QAChC,qCAAqC;IACzC;;IAEA;QACI,8BAA8B;QAC9B,+BAA+B;QAC/B,aAAa;IACjB;;IAEA;QACI,iCAAiC;IACrC;AACJ;;AAEA,iDAAiD;AACjD;IACI,uCAAuC;IACvC;;yCAEqC;AACzC;;AAEA;IACI,UAAU;IACV;;;;;;;KAOC;AACL;;AAEA;IACI,8CAA8C;AAClD;;AAEA;IACI,cAAc;IACd,6CAA6C;AACjD;;AAEA;IACI,eAAe;AACnB;;AAEA,6CAA6C;AAC7C;IACI,uCAAuC;IACvC;;yCAEqC;AACzC;;AAEA;IACI,UAAU;IACV;;;;;;;KAOC;AACL;;AAEA;IACI,8CAA8C;AAClD;;AAEA;IACI,cAAc;IACd,6CAA6C;AACjD;;AAEA;IACI;;wCAEoC;AACxC;;AAEA;IACI;;;;;;;KAOC;IACD,UAAU;AACd;;AAEA;IACI,cAAc;IACd,8CAA8C;AAClD;;AAEA;IACI,cAAc;IACd,4CAA4C;AAChD;;AAEA,sCAAsC;AACtC;IACI;;;0CAGsC;AAC1C;;AAEA;IACI,kBAAkB;IAClB,2BAA2B;IAC3B,2BAA2B;IAC3B,qDAAqD;IACrD,YAAY;IACZ,kBAAkB;IAClB,mCAAmC;IACnC,gBAAgB;IAChB,mCAAmC;IACnC,kBAAkB;IAClB,yBAAyB;IACzB,wCAAwC;IACxC,yCAAyC;IACzC,+CAA+C;AACnD;;AAEA;IACI;QACI,wCAAwC;QACxC,mBAAmB;IACvB;IACA;QACI;iDACyC;QACzC,sBAAsB;IAC1B;IACA;QACI,wCAAwC;QACxC,mBAAmB;IACvB;AACJ","sourcesContent":[".endgame_character {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    width: clamp(120px, 15vw, 180px);\n    height: clamp(120px, 15vw, 180px);\n    padding: clamp(8px, 1vh, 12px);\n    padding-top: clamp(24px, 3vh, 32px);\n    isolation: isolate;\n    background: linear-gradient(\n        135deg,\n        transparent 0%,\n        rgba(37, 43, 54, 0.05) 15%,\n        rgba(37, 43, 54, 0.95) 50%,\n        rgba(37, 43, 54, 0.05) 85%,\n        transparent 100%\n    );\n    border-radius: 8px;\n    transition: all 0.3s ease;\n}\n\n.endgame_character::before {\n    content: '';\n    position: absolute;\n    inset: 0;\n    background: linear-gradient(\n        135deg,\n        transparent 0%,\n        rgba(81, 253, 255, 0.02) 20%,\n        rgba(81, 253, 255, 0.1) 50%,\n        rgba(81, 253, 255, 0.02) 80%,\n        transparent 100%\n    );\n    border-radius: 8px;\n    z-index: -1;\n}\n\n.endgame_character::after {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 10%;\n    right: 10%;\n    height: 1px;\n    background: linear-gradient(\n        90deg,\n        transparent 0%,\n        rgba(81, 253, 255, 0.1) 20%,\n        rgba(81, 253, 255, 0.3) 50%,\n        rgba(81, 253, 255, 0.1) 80%,\n        transparent 100%\n    );\n    opacity: 0.5;\n}\n\n.endgame_character_level {\n    position: absolute;\n    top: clamp(4px, 0.8vh, 8px);\n    right: clamp(8px, 1vw, 12px);\n    font-family: 'Kim';\n    font-size: clamp(12px, 1.5vh, 16px);\n    font-weight: 600;\n    color: #ffa600;\n    text-shadow: 0 0 8px rgba(255, 166, 0, 0.5);\n    display: flex;\n    align-items: center;\n    gap: 4px;\n}\n\n.endgame_character_level span {\n    color: #ffffff;\n}\n\n.endgame_character_level_container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 4px;\n    width: 100%;\n}\n\n.endgame_character_xp_container {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n}\n\n.endgame_character_xp_label {\n    font-size: clamp(8px, 1vh, 10px);\n    color: #71deff;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n    margin-left: 1px;\n}\n\n.endgame_character_xp_bar {\n    width: 100%;\n    height: 4px;\n    background: rgba(28, 31, 37, 0.5);\n    border-radius: 2px;\n    /* overflow: hidden; */\n}\n\n.endgame_character_xp_fill {\n    height: 100%;\n    background: #71deff;\n    box-shadow: 0 0 8px rgba(113, 222, 255, 0.5);\n    transition: width 0.1s linear;\n}\n\n.endgame_character_xp_fill.reset {\n    transition: none;\n}\n\n.endgame_character_portrait {\n    width: clamp(80px, 10vh, 120px);\n    height: clamp(80px, 10vh, 120px);\n    position: relative;\n    margin: 8px 0;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.endgame_character_portrait .char_portrait {\n    width: 100%;\n    height: 100%;\n    margin-left: 10px;\n    background-repeat: no-repeat;\n    transform: scale(1);\n    animation: animate-sprite 0.7s steps(1) infinite;\n}\n\n.endgame_character_portrait .char_portrait.victory-animation {\n    animation: animate-sprite-victory 0.7s steps(1) infinite;\n}\n\n@keyframes animate-sprite-victory {\n    0% { background-position: -900px -190px; }\n    50% { background-position: -1045px -190px; }\n    100% { background-position: -1190px -190px; }\n}\n\n.endgame_character_name {\n    font-family: 'Kim';\n    font-size: clamp(12px, 1.5vh, 16px);\n    font-weight: 600;\n    color: #ffffff;\n    text-align: center;\n    margin-top: 8px;\n    text-shadow: 0 0 8px rgba(255, 255, 255, 0.3);\n}\n\n.endgame_character_class {\n    font-family: 'Kim';\n    font-size: clamp(10px, 2vh, 14px);\n    color: #71deff;\n    text-transform: uppercase;\n    text-align: center;\n    margin-top: 4px;\n}\n\n.endgame_character_exp {\n    font-size: clamp(6px, 0.8vh, 8px);\n    color: #ffffff;\n}\n\n.endgame_character_expVal {\n    font-size: clamp(6px, 0.8vh, 8px);\n    color: #71deff;\n}\n\n.endgame_character_exp_bg {\n    background-color: #1c1f25;\n    height: clamp(3px, 0.5vh, 4px);\n    border-radius: 2px;\n    /* overflow: hidden; */\n}\n\n.endgame_character_lvlup {\n    position: absolute;\n    top: -12px;\n    left: 50%;\n    transform: translateX(-50%);\n    background: linear-gradient(90deg, #ffd700, #ffa600);\n    color: #1c1f25;\n    font-size: clamp(10px, 2.5vw, 12px);\n    font-weight: 700;\n    padding: clamp(4px, 1vh, 6px) clamp(12px, 2vw, 16px);\n    border-radius: 12px;\n    white-space: nowrap;\n    box-shadow: \n        0 0 20px rgba(255, 166, 0, 0.6),\n        0 0 40px rgba(255, 166, 0, 0.3);\n    animation: levelUpFloat 2s ease-in-out infinite;\n    z-index: 2;\n    pointer-events: none;\n    will-change: transform;\n}\n\n.endgame_character.leveling-up::before {\n    content: '';\n    position: absolute;\n    top: -20%;\n    left: -20%;\n    right: -20%;\n    bottom: -20%;\n    background: \n        /* Delayed sparkles */\n        radial-gradient(circle at 50% 30%, rgba(255, 215, 0, 0.8) 0%, transparent 7%),\n        radial-gradient(circle at 25% 50%, rgba(255, 215, 0, 0.8) 0%, transparent 7%),\n        radial-gradient(circle at 75% 50%, rgba(255, 215, 0, 0.8) 0%, transparent 7%),\n        radial-gradient(circle at 50% 70%, rgba(255, 215, 0, 0.8) 0%, transparent 7%);\n    animation: sparkles 1.2s ease-out 0.15s forwards;\n    pointer-events: none;\n    mix-blend-mode: screen;\n}\n\n.endgame_character.leveling-up::after {\n    content: '';\n    position: absolute;\n    top: -20%;\n    left: -20%;\n    right: -20%;\n    bottom: -20%;\n    background: \n        /* Inner sparkles - brighter and closer */\n        radial-gradient(circle at 30% 40%, rgba(255, 215, 0, 0.9) 0%, transparent 6%),\n        radial-gradient(circle at 70% 45%, rgba(255, 215, 0, 0.9) 0%, transparent 6%),\n        radial-gradient(circle at 40% 60%, rgba(255, 215, 0, 0.9) 0%, transparent 6%),\n        radial-gradient(circle at 60% 55%, rgba(255, 215, 0, 0.9) 0%, transparent 6%),\n        /* Outer sparkles - softer and spread out */\n        radial-gradient(circle at 20% 20%, rgba(255, 215, 0, 0.7) 0%, transparent 8%),\n        radial-gradient(circle at 80% 25%, rgba(255, 215, 0, 0.7) 0%, transparent 8%),\n        radial-gradient(circle at 15% 70%, rgba(255, 215, 0, 0.7) 0%, transparent 8%),\n        radial-gradient(circle at 85% 75%, rgba(255, 215, 0, 0.7) 0%, transparent 8%),\n        /* Background glow sparkles */\n        radial-gradient(circle at 40% 30%, rgba(255, 215, 0, 0.5) 0%, transparent 12%),\n        radial-gradient(circle at 60% 70%, rgba(255, 215, 0, 0.5) 0%, transparent 12%);\n    animation: sparkles 1.2s ease-out forwards;\n    pointer-events: none;\n    mix-blend-mode: screen;\n}\n\n@keyframes levelUpFloat {\n    0%, 100% {\n        transform: translateX(-50%) translateY(0);\n    }\n    50% {\n        transform: translateX(-50%) translateY(-4px);\n    }\n}\n\n@keyframes sparkles {\n    0% { \n        opacity: 0; \n        transform: scale(0.8) rotate(-5deg); \n    }\n    15% {\n        opacity: 0.3;\n        transform: scale(0.9) rotate(-3deg);\n    }\n    50% { \n        opacity: 1; \n        transform: scale(1.1) rotate(2deg); \n    }\n    75% {\n        opacity: 0.6;\n        transform: scale(1.15) rotate(4deg);\n    }\n    100% { \n        opacity: 0; \n        transform: scale(1.2) rotate(5deg); \n    }\n}\n\n@media screen and (max-width: 480px) {\n    .endgame_character_lvlup {\n        top: -8px;\n        padding: 3px 10px;\n        border-radius: 8px;\n    }\n}\n\n.endgame_character.question-mark-mode {\n    cursor: pointer;\n    transition: transform 0.3s ease;\n    width: clamp(120px, 15vw, 180px);\n    height: clamp(120px, 15vw, 180px);\n    padding: clamp(8px, 1vh, 12px);\n    padding-top: clamp(24px, 3vh, 32px);\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    background: linear-gradient(\n        135deg,\n        transparent 0%,\n        rgba(37, 43, 54, 0.05) 15%,\n        rgba(37, 43, 54, 0.95) 50%,\n        rgba(37, 43, 54, 0.05) 85%,\n        transparent 100%\n    );\n    border-radius: 8px;\n}\n\n.endgame_character.question-mark-mode::before {\n    content: '';\n    position: absolute;\n    inset: 0;\n    background: linear-gradient(\n        135deg,\n        transparent 0%,\n        rgba(81, 253, 255, 0.02) 20%,\n        rgba(81, 253, 255, 0.1) 50%,\n        rgba(81, 253, 255, 0.02) 80%,\n        transparent 100%\n    );\n    border-radius: 8px;\n    z-index: -1;\n}\n\n.endgame_character.question-mark-mode .endgame_character_portrait {\n    width: clamp(80px, 10vh, 120px);\n    height: clamp(80px, 10vh, 120px);\n    margin: 8px 0;\n}\n\n.endgame_character.question-mark-mode .char_portrait {\n    display: none;\n}\n\n.endgame_character.question-mark-mode .question-mark {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-family: 'Kim';\n    font-size: clamp(48px, 8vw, 72px);\n    color: #3c616c;\n    text-shadow: 0 0 20px rgba(81, 253, 255, 0.2);\n    margin-left: 0;\n}\n\n.endgame_character.question-mark-mode:hover {\n    transform: translateY(-5px);\n    border-color: #51fdff;\n    box-shadow: 0 0 20px rgba(81, 253, 255, 0.2);\n}\n\n@media screen and (max-width: 480px) {\n    .endgame_character,\n    .endgame_character.question-mark-mode {\n        width: clamp(100px, 12vw, 160px);\n        height: clamp(100px, 12vw, 160px);\n        padding: clamp(6px, 0.8vh, 10px);\n        padding-top: clamp(20px, 2.5vh, 28px);\n    }\n\n    .endgame_character.question-mark-mode .endgame_character_portrait {\n        width: clamp(60px, 8vh, 100px);\n        height: clamp(60px, 8vh, 100px);\n        margin: 6px 0;\n    }\n\n    .endgame_character.question-mark-mode .question-mark {\n        font-size: clamp(36px, 6vw, 54px);\n    }\n}\n\n/* Add hover effect for non-question-mark cards */\n.endgame_character:not(.question-mark-mode):hover {\n    transform: translateY(-5px) scale(1.02);\n    box-shadow: \n        0 5px 15px rgba(81, 253, 255, 0.1),\n        0 0 30px rgba(81, 253, 255, 0.05);\n}\n\n.endgame_character:not(.question-mark-mode):hover::before {\n    opacity: 1;\n    background: linear-gradient(\n        135deg,\n        transparent 0%,\n        rgba(81, 253, 255, 0.04) 15%,\n        rgba(81, 253, 255, 0.15) 50%,\n        rgba(81, 253, 255, 0.04) 85%,\n        transparent 100%\n    );\n}\n\n.endgame_character:not(.question-mark-mode):hover .endgame_character_name {\n    text-shadow: 0 0 12px rgba(255, 255, 255, 0.5);\n}\n\n.endgame_character:not(.question-mark-mode):hover .endgame_character_class {\n    color: #9ee5ff;\n    text-shadow: 0 0 8px rgba(113, 222, 255, 0.5);\n}\n\n.endgame_character.clickable {\n    cursor: pointer;\n}\n\n/* Enhance hover effect for clickable cards */\n.endgame_character.clickable:hover {\n    transform: translateY(-5px) scale(1.02);\n    box-shadow: \n        0 5px 15px rgba(81, 253, 255, 0.1),\n        0 0 30px rgba(81, 253, 255, 0.05);\n}\n\n.endgame_character.clickable:hover::before {\n    opacity: 1;\n    background: linear-gradient(\n        135deg,\n        transparent 0%,\n        rgba(81, 253, 255, 0.04) 15%,\n        rgba(81, 253, 255, 0.15) 50%,\n        rgba(81, 253, 255, 0.04) 85%,\n        transparent 100%\n    );\n}\n\n.endgame_character.clickable:hover .endgame_character_name {\n    text-shadow: 0 0 12px rgba(255, 255, 255, 0.5);\n}\n\n.endgame_character.clickable:hover .endgame_character_class {\n    color: #9ee5ff;\n    text-shadow: 0 0 8px rgba(113, 222, 255, 0.5);\n}\n\n.endgame_character.selected {\n    box-shadow: \n        0 0 0 2px #51fdff,\n        0 0 15px rgba(81, 253, 255, 0.3);\n}\n\n.endgame_character.selected::before {\n    background: linear-gradient(\n        135deg,\n        transparent 0%,\n        rgba(81, 253, 255, 0.04) 15%,\n        rgba(81, 253, 255, 0.15) 50%,\n        rgba(81, 253, 255, 0.04) 85%,\n        transparent 100%\n    );\n    opacity: 1;\n}\n\n.endgame_character.selected .endgame_character_name {\n    color: #9ee5ff;\n    text-shadow: 0 0 12px rgba(113, 222, 255, 0.5);\n}\n\n.endgame_character.selected .endgame_character_class {\n    color: #51fdff;\n    text-shadow: 0 0 8px rgba(81, 253, 255, 0.5);\n}\n\n/* Combine hover and selected states */\n.endgame_character.selected:hover {\n    box-shadow: \n        0 0 0 2px #51fdff,\n        0 0 20px rgba(81, 253, 255, 0.4),\n        0 5px 15px rgba(81, 253, 255, 0.2);\n}\n\n.endgame_character_sp_badge {\n    position: absolute;\n    top: clamp(4px, 0.8vh, 8px);\n    left: clamp(8px, 1vw, 12px);\n    background: linear-gradient(135deg, #ff4646, #ff0000);\n    color: white;\n    font-family: 'Kim';\n    font-size: clamp(10px, 1.2vh, 14px);\n    font-weight: 600;\n    padding: 2px clamp(4px, 0.5vw, 6px);\n    border-radius: 4px;\n    text-transform: uppercase;\n    box-shadow: 0 0 8px rgba(255, 0, 0, 0.4);\n    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);\n    animation: spBadgePulse 2s ease-in-out infinite;\n}\n\n@keyframes spBadgePulse {\n    0% {\n        box-shadow: 0 0 8px rgba(255, 0, 0, 0.4);\n        transform: scale(1);\n    }\n    50% {\n        box-shadow: 0 0 12px rgba(255, 0, 0, 0.6),\n                    0 0 20px rgba(255, 0, 0, 0.2);\n        transform: scale(1.05);\n    }\n    100% {\n        box-shadow: 0 0 8px rgba(255, 0, 0, 0.4);\n        transform: scale(1);\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
